import { BlogPostEntity, BlogPostSchema, CommentEntity, CommentSchema } from 'mk2/apps/blogs/schemas';
import { MessageSchema, PostEntity, PostSchema } from 'mk2/apps/forum/schemas';
import { Entity, UserEntity, UserSchema } from 'mk2/schemas';
import { schema } from 'normalizr';

export const complaintKey = (entity: string, id: number): string => `${entity}/${id}`;

interface UnionKey {
    schema: 'forum-message' | 'forum-thread' | 'photoblog-comment' | 'photoblog-post';
}

export interface ComplaintEntity extends Entity {
    readonly user: UserEntity;
    readonly target: (BlogPostEntity | CommentEntity | PostEntity) & UnionKey;
    readonly comment: string;
    readonly createdAt: string;
    readonly deletedAt: string;
}

const TargetSchema = new schema.Union({
    'forum-message': MessageSchema,
    'forum-thread': PostSchema,
    'photoblog-post': BlogPostSchema,
    'photoblog-comment': CommentSchema,
}, 'target');

export const ComplaintSchema = new schema.Entity('complaints', {
    user: UserSchema,
    target: TargetSchema,
});
